import {
  ASPECT_RATIOS,
  AspectRatioKey,
  DesignChannel,
  getAspectRatioKeyFromDesignChannel,
} from 'components/NewFileModal/Types'
import { TextChannels } from '../constants'
import { TextChannelKey } from 'types'

export const getChannelInfo = (channelKey: TextChannelKey | AspectRatioKey) => {
  return TextChannels[channelKey as TextChannelKey] ?? ASPECT_RATIOS[channelKey as AspectRatioKey] ?? {}
}

export const getChannelKeyFromTextOrDesignChannel = (
  channelKey: TextChannelKey | DesignChannel,
  width: number,
  height: number,
) => {
  const textChannel = TextChannels[channelKey as TextChannelKey]
  if (textChannel) {
    return channelKey as TextChannelKey
  }

  return getAspectRatioKeyFromDesignChannel(channelKey as DesignChannel, width, height)
}
